var _path, _path2, _path3, _circle, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIdpProjectDocumentUpload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 101 108"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#BBBCBC",
  d: "M55.5.5H0v79.643h55.5V.5m-6.13 73.512H6.13V6.63h43.24v67.382"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20 19v71h53V35.422L58.363 19z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#BBBCBC",
  d: "M75.644 27.254 63.89 15.5H15v79.643h64.697V31.307zm-2.077 61.758H21.13V21.63h34.046v18.391h18.39z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 77,
  cy: 84,
  r: 24,
  fill: "#FF832B"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m65 90.201 12-20.784L89 90.2l-7.203-1.12v6.45h-9.593v-6.45z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#BBBCBC",
  d: "M28 33h20v7H28zM28 48h27v7H28z"
})));
export default SvgIdpProjectDocumentUpload;